var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrystalButterfly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1065,
    height: 872,
    viewBox: "0 0 1065 872",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M434.37 812.11L11.908 332.427C8.5581 328.623 12.3418 322.823 17.1729 324.357L223.91 389.974C225.17 390.374 226.22 391.257 226.831 392.429L343.726 616.799V176.498C343.726 175.853 343.851 175.215 344.093 174.618L412.765 5.32903C413.907 2.51401 417.275 1.35934 419.904 2.88144L609.309 112.541C610.597 113.287 611.486 114.568 611.734 116.035L649.8 341.221C650.257 343.924 652.805 345.755 655.512 345.326L822.1 318.968C822.358 318.927 822.62 318.906 822.881 318.906H1035.16C1038.23 318.906 1040.57 321.646 1040.1 324.678L1006.89 537.231C1006.72 538.33 1006.19 539.34 1005.38 540.102L823.523 711.005C822.846 711.64 822.007 712.075 821.097 712.26L434.528 791.085L442.557 806.495C445.285 811.732 438.273 816.542 434.37 812.11Z",
    fill: "url(#paint0_angular_120_68)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M458.37 841.11L35.908 361.427C32.5581 357.623 36.3418 351.823 41.1729 353.357L247.91 418.974C249.17 419.374 250.22 420.257 250.831 421.429L367.726 645.799V205.498C367.726 204.853 367.851 204.215 368.093 203.618L436.765 34.329C437.907 31.514 441.275 30.3593 443.904 31.8814L633.309 141.541C634.597 142.287 635.486 143.568 635.734 145.035L673.8 370.221C674.257 372.924 676.805 374.755 679.512 374.326L846.1 347.968C846.358 347.927 846.62 347.906 846.881 347.906H1059.16C1062.23 347.906 1064.57 350.646 1064.1 353.678L1030.89 566.231C1030.72 567.33 1030.19 568.34 1029.38 569.102L847.523 740.005C846.846 740.64 846.007 741.075 845.097 741.26L458.528 820.085L466.557 835.495C469.285 840.732 462.273 845.542 458.37 841.11Z",
    fill: "url(#paint1_angular_120_68)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_120_68",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(333.906 598.258) rotate(62.1231) scale(257.295 318.69)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_120_68",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(357.906 627.258) rotate(62.1231) scale(257.295 318.69)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC",
    stopOpacity: 0.54
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrystalButterfly);
export default __webpack_public_path__ + "static/media/crystalButterfly.017a6c4050416221bf5a3b10343a2e61.svg";
export { ForwardRef as ReactComponent };